import { render, staticRenderFns } from "./notification-bar.vue?vue&type=template&id=45c79ee3&scoped=true"
import script from "./notification-bar.vue?vue&type=script&lang=js"
export * from "./notification-bar.vue?vue&type=script&lang=js"
import style0 from "./notification-bar.vue?vue&type=style&index=0&id=45c79ee3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c79ee3",
  null
  
)

export default component.exports